import React from 'react';

import './Logo.css';

const logo = props => <h1 className="logo">پنل ادمین</h1>;

export default logo;
